import React from 'react'
import clsx from 'clsx'
import {
  Box,
} from '@material-ui/core'
import {
  PlayCircleFilledWhite as PlayCircleFilledWhiteIcon,
  PauseCircleFilled as PauseCircleFilledIcon,
  Replay as ReplayIcon,
  VolumeUp as VolumeUpIcon
} from '@material-ui/icons'

const SlotControl = props => {
  return (
    <Box className={props.classes.timerControls}>
      {props.timerActive ?
        <PauseCircleFilledIcon
          className={props.classes.iconControl}
          fontSize='large'
          onClick={props.onClickPause}
        />
        :
        <PlayCircleFilledWhiteIcon
          className={props.classes.iconControl}
          fontSize='large'
          onClick={props.onClickPlay}
        />
      }
      <ReplayIcon
        className={props.classes.iconControl}
        fontSize='large'
        onClick={props.onClickReset}
      />
      <VolumeUpIcon
        fontSize='large'
        className={clsx({
          [props.classes.iconActive]: props.beepActive,
          [props.classes.iconDisabled]: !props.beepActive,
        })}
      />
    </Box>

  )
}

export default SlotControl